import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { CmsComponentData } from '@spartacus/storefront';
import { ContentPageGridService } from './core/content-page-grid.service';
import { BehaviorSubject, Subscription, switchMap, take } from 'rxjs';
import { PageGridContainer } from './core/content-page-grid.model';

@Component({
  selector: 'content-page-grid',
  templateUrl: './content-page-grid.component.html',
  styleUrl: './content-page-grid.component.scss',
  standalone: false,
})
export class ContentPageGridComponent implements OnInit, OnDestroy {
  @HostBinding('class.content-page-grid') isActive = true;

  pagesGrid$ = new BehaviorSubject<PageGridContainer | undefined>(undefined);
  subscription = new Subscription();

  constructor(
    private componentData: CmsComponentData<any>,
    private contentPageGridService: ContentPageGridService,
  ) {}

  ngOnInit(): void {
    this.getContent();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  getContent() {
    this.subscription.add(
      this.componentData.data$
        .pipe(
          take(1),
          switchMap(data => this.contentPageGridService.normalize(data)),
        )
        .subscribe(pageGrid => {
          this.pagesGrid$.next(pageGrid);
        }),
    );
  }
}
